import { render, staticRenderFns } from "./LisData.vue?vue&type=template&id=d687dfd2&scoped=true"
import script from "./LisData.vue?vue&type=script&lang=js"
export * from "./LisData.vue?vue&type=script&lang=js"
import style0 from "./LisData.vue?vue&type=style&index=0&id=d687dfd2&prod&scoped=true&lang=css"
import style1 from "./LisData.vue?vue&type=style&index=1&id=d687dfd2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d687dfd2",
  null
  
)

export default component.exports